












































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { truncateText, transparentPng1x1 } from '@/utils/common'

@Component
export default class GuiaTissInternacao extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get guiaTissGroupedByProcedimento() {
    return this.getBackofficeGlobalStore.guiaTissGroupedByProcedimento
  }

  get hospitalRemoveParticularDaGuiaTiss() {
    return this.getBackofficeGlobalStore.guiaTissInternacaoOpme.hospitalRemoveParticularDaGuiaTiss
  }

  get procedimentosComParticularesRemovidos() {
    if (!this.hospitalRemoveParticularDaGuiaTiss) {
      return this.guiaTissGroupedByProcedimento
    }

    return this.guiaTissGroupedByProcedimento.map((guia: any) => ({
      ...guia,
      procedimentos: guia.procedimentos
        ? guia.procedimentos.filter((proc: any) => !proc.particular)
        : [],
    }))
  }

  get guiaTissGroupedByProcedimentosVisiveis() {
    return this.procedimentosComParticularesRemovidos.map((guia: any) => ({
      ...guia,
      procedimentosVisiveis: guia.procedimentos || [],
    }))
  }


  tipoProcedimentoEnum(tipo: any) {
    switch (tipo) {
      case 1:
        return 1
      case 2:
        return 1
      case 3:
        return 2
      default:
        return 1
    }
  }

  assinatura(signature: string | null | undefined) {
    return `data:image/png;base64,${signature || transparentPng1x1()}`
  }

  maskText(sentence: string, limit: number = 9999) {
    if (['', null, undefined].includes(sentence)) return ''
    return truncateText(sentence, limit)
  }

  maskDateTime(date: any) {
    const formatter = new Intl.DateTimeFormat("pt-BR", {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: 'America/Sao_Paulo',
    })
    return ['', null, undefined].includes(date)
      ? ''
      : formatter.format(new Date(date))
  }

  maskDate(date: any) {
    const formatter = new Intl.DateTimeFormat('pt-BR')
    return ['', null, undefined].includes(date)
      ? ''
      : formatter.format(new Date(date))
  }

  maskCPFCNPJ(v: string) {
    if (['', null, undefined].includes(v) || ![11, 14].includes(v.length)) return ''
    if (v.length === 14) return `${v.substring(0, 2)}.${v.substring(2, 5)}.${v.substring(5, 8)}/${v.substring(8, 12)}-${v.substring(12, 14)}`
    return `${v.substring(0, 3)}.${v.substring(3, 6)}.${v.substring(6, 9)}-${v.substring(9, 11)}`
  }
}
